<template>
    <div class="project_py">
        <div class="information">
            <span class="information_bar"></span>
            <span class="information_zh">图话濮阳</span>
            <span class="information_en">PICTURE OF PUYANG</span>
            <div class="more_conent" @click="newsPuyang('707bd938-4b23-43f1-94be-b25d06fc60aa','图话濮阳')">
                <img src="../images/more.png" alt="">
                <span class="more_py">更多</span>
            </div>
        </div>
        <div class="picture_of">
            <div class="picture_list">
                <p v-if="Loading" style="text-align: center;height: 220px;line-height: 220px;"><mt-spinner type="triple-bounce"></mt-spinner></p>
                <div class="pic_content" v-for="item in picListPart" :key="item.id" @click="columnData(item,'图话濮阳')">
                    <div class="imgxianz">
                        <img :src="item.image_url" alt="">
                        <!-- <el-image v-if="item.image_url != ''" :src="item.image_url" lazy></el-image> -->
                        <img v-if="item.image_url == ''" src="../images/defaultimg.png" alt=""> 
                    </div>
                    
                    <p>{{item.title}}</p>
                </div>
            </div>

            <div class="pic_information">
                <div class="news_py">
                    <p class="news_title">
                        <span class="name_py">文化龙乡</span>
                        <span class="moreList" @click="newsPuyang('098accbe-1f7a-4dd6-b097-e30b1ae2e2f2','文化龙乡')">
                            <img src="../images/more.png" alt="">
                            <span class="more_py">更多</span>
                        </span>
                    </p>
                    <p v-if="Loadingnew" style="text-align: center;height: 220px;line-height: 220px;"><mt-spinner type="triple-bounce"></mt-spinner></p>
                    <div class="pic_top" v-for="item in shufflingFunterst" :key="item.id" @click="columnData(item,'文化龙乡')">
                        <span class="contents_img" v-if="item.image_url != ''">
                            <img class="cont_images" :src="item.image_url" alt="">
                            <!-- <el-image class="cont_images" :src="item.image_url" lazy></el-image> -->
                        </span>
                        <span class="contents_img" v-if="item.image_url == ''">
                            <img class="cont_images" src="../images/defaultimg.png" alt="">
                        </span>
                        <p class="pic_intro">{{item.title}}</p>
                    </div>
                    <ul class="pic_list">
                        <li v-for="item in shufflingFunList" :key="item.id" @click="columnData(item,'文化龙乡')"><i class="el-icon-caret-right"></i>{{item.title}}</li>
                    </ul>
                </div>
                <div class="news_py">
                    <p class="news_title">
                        <span class="name_py">招商引资</span>
                        <span class="moreList" @click="newsPuyang('b31fb2b6-ec1c-4c2d-898a-d3121c072d7a','招商引资')">
                            <img src="../images/more.png" alt="">
                            <span class="more_py">更多</span>
                        </span>
                    </p>
                    <p v-if="Loadingnews" style="text-align: center;height: 220px;line-height: 220px;"><mt-spinner type="triple-bounce"></mt-spinner></p>
                    <div class="pic_top" v-for="item in merchFunterst" :key="item.id" @click="columnData(item,'招商引资')">
                        <span class="contents_img" v-if="item.image_url != ''">
                            <img class="cont_images" :src="item.image_url" alt="">
                            <!-- <el-image class="cont_images" :src="item.image_url" lazy></el-image> -->
                        </span>
                        <span class="contents_img" v-if="item.image_url == ''"><img class="cont_images" src="../images/defaultimg.png" alt=""></span>
                        <p class="pic_intro">{{item.title}}</p>
                    </div>

                    <ul class="pic_list">
                        <li v-for="item in merchFunList" :key="item.id" @click="columnData(item,'招商引资')"><i class="el-icon-caret-right"></i>{{item.title}}</li>
                    </ul>
                </div>
                <div class="news_py">
                    <p class="news_title">
                        <span class="name_py">关注民生</span>
                        <span class="moreList" @click="newsPuyang('27dde13d-e3f1-44cb-8bd0-fd90db9af312','关注民生')">
                            <img src="../images/more.png" alt="">
                            <span class="more_py">更多</span>
                        </span>
                    </p>
                    <p v-if="Loadingnewsif" style="text-align: center;height: 220px;line-height: 220px;"><mt-spinner type="triple-bounce"></mt-spinner></p>
                    <div class="pic_top" v-for="item in liveFunterst" :key="item.id" @click="columnData(item,'关注民生')">
                        <span class="contents_img" v-if="item.image_url != ''">
                            <img class="cont_images" :src="item.image_url" alt="">
                        </span>
                        <span class="contents_img" v-if="item.image_url == ''"><img class="cont_images" src="../images/defaultimg.png" alt=""></span>
                        <p class="pic_intro">{{item.title}}</p>
                    </div>

                    <ul class="pic_list">
                        <li v-for="item in liveFunList" :key="item.id" @click="columnData(item,'关注民生')"><i class="el-icon-caret-right"></i>{{item.title}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {listApi , columnNewsList,generateSign} from '@/api/index'
import Bus from '@/Bus'
// 濮阳新闻
const shufflingParameter = {
    pageNum: 0,
    pageSize: 10,
    columnId: "098accbe-1f7a-4dd6-b097-e30b1ae2e2f2",
    userId: "",
    appInfoId: "10"
}
// 关注民生
const livelihoodParameter = {
    pageNum: 0,
    pageSize: 10,
    columnId: "27dde13d-e3f1-44cb-8bd0-fd90db9af312",
    userId: '',
    appInfoId: "10"
}
// 招商引资
const merchantsParameter = {
    pageNum: 0,
    pageSize: 10,
    columnId: "b31fb2b6-ec1c-4c2d-898a-d3121c072d7a",
    userId: "",
    appInfoId: "10"
}
const picParameter = {
    pageNum: 0,
    pageSize: 10,
    columnId: "707bd938-4b23-43f1-94be-b25d06fc60aa",
    userId: "",
    appInfoId: "10"
}
export default {
    data(){
        return {
            Loading:true,
            Loadingnew:true,
            Loadingnews:true,
            Loadingnewsif:true,
            jumpRouting:true,
            shuParameter: Object.assign({}, shufflingParameter),
            shufflingFunList:null,
            shufflingPicture:[],
            shufflingFunterst:null,

            // 关注民生
            liveParameter: Object.assign({}, livelihoodParameter),
            liveFunList:null,
            livePicture:[],
            liveFunterst:null,

            // 招商引资
            merchParameter: Object.assign({}, merchantsParameter),
            merchFunList:null,
            merchPicture:[],
            merchFunterst:null,

            // 图话濮阳
            picParame: Object.assign({}, picParameter),
            picListPart:null,

        }
    },
    created(){
        this.shufflingFun()
        this.liveLingFun()
        this.merchLingFun()
        this.picTew()
    },
    methods:{
        // 濮阳新闻
        async shufflingFun(){
            const headers = { 
        'Sign': generateSign()
      };
            const res = await this.axios.post(listApi,this.shuParameter,{ headers })
            this.shufflingFunterst = res.data.data[0].list.splice(0,1)
            this.shufflingFunList = res.data.data[0].list.splice(0,5)
            this.Loadingnew = false
        },
        // 关注民生
        async liveLingFun(){
            const headers = { 
        'Sign': generateSign()
      };
            const res = await this.axios.post(listApi,this.liveParameter,{ headers })
            this.liveFunterst = res.data.data[0].list.splice(0,1)
            this.liveFunList = res.data.data[0].list.splice(0,5)
            this.Loadingnewsif = false
        },
        // 招商引资
        async merchLingFun(){
            const headers = { 
        'Sign': generateSign()
      };
            const res = await this.axios.post(listApi,this.merchParameter,{ headers })
            this.merchFunterst = res.data.data[0].list.splice(0,1)
            this.merchFunList = res.data.data[0].list.splice(0,5)
            this.Loadingnews = false
        },

        // 列表详情跳转
        columnData(type , title){
            let routeData = this.$router.resolve({ path: '/details', query: {  id: type.id,jsonUrl:type.jsonUrl ,title } });
            window.open(routeData.href, '_blank');
            Bus.$emit('jumpRouting', false );
        },
        // 获取濮阳新闻更多列表
        newsPuyang(columnId,title){
            let routeData = this.$router.resolve({ path: '/contentList', query: {  columnId:columnId , title:title } });
            window.open(routeData.href, '_blank');
            Bus.$emit('jumpRouting', false );
        },
        async picTew(){
            const headers = { 
        'Sign': generateSign()
      };
            const res = await this.axios.post(columnNewsList,this.picParame,{ headers })
            this.picListPart = res.data.data[0].list.splice(0,5)
            this.Loading = false
        }
    }
}
</script>
<style lang="">
    .moreList img{
        cursor:pointer; 
    }
    .moreList span{
        cursor:pointer; 
    }
    .project_py{
        margin-top:44px;
        border-top:2px solid rgba(201,3,4,1);
    }
    .project_py .information{
        height:45px;
        line-height:45px;
        border-bottom:1px solid rgba(210,210,210,1);;
    }
    .information  .information_bar{
        margin:0 10px 0 16px;
        border-left:3px solid rgba(201,3,4,1);
    }
    .information .information_zh{
         height:18px;
         color:rgba(201,3,4,1);
         font-size:18px;
         font-weight: bolder;
    }
    .information .information_en{
        font-size: 18px;
        color:#646464;
        font-weight: 400;
        margin-left:10px;
    }
    .more_conent{
        width:60px;
        float:right;
        cursor:pointer;
    }
    .more_conent .more_py{
        font-size: 12px;
        font-weight: 400;
        width:28px;
        float:right;
        color:#969696;
    }
    .more_conent img{
        width:14px;
        height:14px;
        float:right;
        padding-top:15px;
        cursor:pointer; 
        padding-right: 6px;
    }
    .picture_of{
        height:750px;
    }
    .picture_of .picture_list{
        height:220px;
        padding:24px 12px 0;
    }
    .picture_of .picture_list .pic_content{
        width:220px;
        float:left;
        overflow:hidden;
        cursor:pointer; 
        margin:0 7px ;
    }
    .picture_of .picture_list .pic_content .imgxianz{
        width:220px;
        height:140px;
        text-align: center;
        background:rgb(247, 247, 247);
    }
    .picture_of .picture_list .pic_content img{
        height:140px;
    }
    .picture_of .picture_list .pic_content p{
        width:220px;
        padding-top:12px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        font-size:16px;
        line-height:20px;
        color:#333333;
    }
    .pic_information{
        height:496px;
    }
    .pic_information .news_py{
        width: 386px;
        min-height:276px;
        float: left;
        padding-right:20px;
    }
    .pic_information .news_py:last-of-type{
        width: 386px;
        min-height:276px;
        float: left;
        padding:0;
    }
    .pic_information .news_py .news_title{
        height:40px;
        line-height:40px;
        border-top:1px solid #D2D2D2;
        border-bottom:1px solid #D2D2D2;
        background:rgba(235, 233, 233, 0.5);
    }
    .pic_information .news_py .name_py{
        width:68px;
        color:#000;
        font-size: 16px;
        font-weight: bolder;
        border-top:2px solid #C90304;
        padding-top:8px;
        margin-left:10px;
    }
    .pic_information .news_py .more_py{
        cursor:pointer; 
        font-size: 12px;
        font-weight: 400;
        width:28px;
        float:right;
        color:#969696;
    }
    .pic_information .news_py p img{
        width:14px;
        height:14px;
        float:right;
        padding-top:13px;
        cursor:pointer; 
        padding-right: 6px;
    }
    .pic_information .pic_top{
        cursor:pointer; 
        position:relative;
    }
    .pic_information .pic_top .pic_intro{
        cursor:pointer; 
        width:346px;
        height:50px;
        position:absolute;
        bottom:0;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        left:0;
        line-height:50px;
        background:rgba(0,0,0,0.5);
        padding:0 20px;
        color:#FFFFFF;
        font-size: 16px;
    }
    .pic_information .pic_top .contents_img{
        width:386px;
        height:240px;
        display: block;
        margin-top:10px !important;
    }
    .pic_information .pic_top .contents_img .cont_images{
        width:100%;
        height:100%;
    }
    .pic_list li{
        cursor:pointer; 
        overflow: hidden;
        border-bottom:0.5px dashed #DCDCDC;
        text-overflow:ellipsis;
        white-space: nowrap;
        width:386px;
        font-size:16px;
        line-height:30px;
    }
    .pic_list i{
        color:#F8696A;
        margin-right:10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/components/pictureOfPuyang.vue